import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import * as actions from './action-types';
import { api } from './api';
import { createDescriptionSelector } from 'app/infrastructure/translate/index';
import { UiState } from 'app/infrastructure/ui/form/types';
import { exportToZipTranslations } from 'app/area/my-downloads/exports/export-to-zip-modal/constants';
import { toastFactory, AutoCloseDuration } from 'app/infrastructure/notifications/toast-factory';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages';

export const actionCreators = {

  exportCases: (favouriteId: string, serializedData, successMessage): ActionDispatching<any, ApplicationState> =>
    async (dispatch: any, getState: any) => {

      const toastMessage = toastFactory({ autoClose: AutoCloseDuration.Longer });

      try {
        dispatch(new actions.RequestExportCases());
        const areaState = getState().myDownloads as UiState;
        const translationDescription = createDescriptionSelector(areaState.texts);

        toastMessage.dispatchSuccess(translationDescription(exportToZipTranslations.export_modal_wait));

        const definition = await api.loadFavouriteDefinition(favouriteId);

        const newDefinition = {
          ...definition,
          comments: serializedData.comments,
          selectedReport: { v: 9 }
        };

        const favoruriteDefinition = await api.exportCases(newDefinition);

        dispatch(new actions.ReceiveExportCases(favoruriteDefinition));
        toastMessage.updateSuccess(successMessage);

      } catch (err) {
        dispatch(new actions.FailExportCases());
        dispatch(new ErrorNotification(err.userMessages || err.message));
      }
    }
};
